import { render, staticRenderFns } from "./checkbox-input.vue?vue&type=template&id=2497493c&scoped=true&"
import script from "./checkbox-input.vue?vue&type=script&lang=js&"
export * from "./checkbox-input.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-input.vue?vue&type=style&index=0&id=2497493c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497493c",
  null
  
)

export default component.exports